import { createAsyncThunk } from '@reduxjs/toolkit';

export const qrAccountView = createAsyncThunk(
    'users/view/qracc',
    async (_, thunkAPI,) => {

        try {
            const res = await fetch(`/api/users/view/qracc`, {
                method: 'GET',
                headers: {
                    Accept: 'application/JSON',
                    'Content-Type': 'application/json'
                },
            });


            const data = await res.json();

            if (res.status === 200) {
                return data;

            } else {
                console.log("qrAccountView != 200 -----------------------");
                return thunkAPI.rejectWithValue(data);
            }

        } catch (err) {
            console.log("qrAccountView Error -----------------------");
            console.log(err);
            return thunkAPI.rejectWithValue(err.response.data);
        }
    }
);